// Форматтеры сводного дэшборда. Денежные и процентные — из '@/views/finance/utils'.
const MONTHS_SHORT = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']

export const formatDateTime = iso => {
  if (!iso) return '—'
  const date = new Date(iso)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}.${month}, ${hours}:${minutes}`
}

export const formatDate = iso => {
  if (!iso) return '—'
  const date = new Date(iso)
  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export const formatNumber = value => {
  if (value === null || value === undefined) return '—'
  return new Intl.NumberFormat('ru-RU').format(value)
}

export const formatDelta = (value, suffix = ' %') => {
  if (value === null || value === undefined) return '—'
  const rounded = Math.round(value * 10) / 10
  const sign = rounded > 0 ? '+' : (rounded < 0 ? '−' : '')
  return `${sign}${new Intl.NumberFormat('ru-RU').format(Math.abs(rounded))}${suffix}`
}

export const deltaVariant = value => {
  if (value === null || value === undefined || value === 0) return 'secondary'
  return value > 0 ? 'success' : 'danger'
}

export const monthLabel = yyyyMm => {
  if (!yyyyMm) return ''
  const [year, month] = yyyyMm.split('-')
  return `${MONTHS_SHORT[Number(month) - 1]} ${year}`
}
